(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('TrRoutePlanDeleteController',TrRoutePlanDeleteController);

    TrRoutePlanDeleteController.$inject = ['$uibModalInstance', 'entity', 'TrRouteBundle','$scope'];

    function TrRoutePlanDeleteController($uibModalInstance, entity, TrRouteBundle,$scope) {
        var vm = this;

        vm.trRoute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	$scope.deletefail = true;
            TrRouteBundle.delete({id: id},
                function () {
            	
            	 $scope.deletefail = false;
                    $uibModalInstance.close(true);
                });
           
        }
    }
})();
